import { render, staticRenderFns } from "./ClubPlayerStatistics.vue?vue&type=template&id=bd2d1e5a&scoped=true"
import script from "./ClubPlayerStatistics.vue?vue&type=script&lang=js"
export * from "./ClubPlayerStatistics.vue?vue&type=script&lang=js"
import style0 from "./ClubPlayerStatistics.vue?vue&type=style&index=0&id=bd2d1e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d1e5a",
  null
  
)

export default component.exports